import { render, staticRenderFns } from "./TailwindTable.vue?vue&type=template&id=08950938&scoped=true"
import script from "./TailwindTable.vue?vue&type=script&lang=js"
export * from "./TailwindTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08950938",
  null
  
)

export default component.exports